const pollContainer = document.querySelector('.poll');
const pollId = pollContainer.dataset.pollId;
const pollDisplayDelay = pollContainer.dataset.pollDisplayDelay;

const closeButton = pollContainer.querySelector('.poll__close');
const submitButton = pollContainer.querySelector('button[type="submit"]');

const pollForm = pollContainer.querySelector('.poll__form');
const pollEndpoint = pollForm.getAttribute('action');
const pollSuccessContainer = pollContainer.querySelector('.poll__status-container--success');
const pollErrorContainer = pollContainer.querySelector('.poll__status-container--error');

const hiddenPolls = localStorage.getItem('hiddenPolls')
    ? localStorage.getItem('hiddenPolls').split(',')
    : [];

const displayPoll = (delay = 0) => {
    if (hiddenPolls.includes(pollId)) return;

    setTimeout(() => {
        pollContainer.hidden = false;
    }, delay);
};

const closePoll = (delay = 0) => {
    hiddenPolls.push(pollId);
    localStorage.setItem('hiddenPolls', hiddenPolls.join(','));

    setTimeout(() => {
        pollContainer.classList.add('poll--closed');

        pollContainer.addEventListener(
            'animationend',
            () => {
                pollContainer.hidden = true;
            },
            { once: true },
        );
    }, delay);
};

const displaySuccessMessage = () => {
    pollForm.classList.add('poll__form--hidden');
    pollSuccessContainer.classList.add('poll__status-container--visible');
    pollForm.hidden = true;
    pollSuccessContainer.hidden = false;
};

const displayErrorMessage = () => {
    pollForm.classList.add('poll__form--hidden');
    pollErrorContainer.classList.add('poll__status-container--visible');
    pollForm.hidden = true;
    pollErrorContainer.hidden = false;
};

const submitPoll = event => {
    const formData = new FormData(pollForm);
    const pollResponse = formData.get('poll_response');
    const turnstileResponse = formData.get('cf-turnstile-response');

    event.preventDefault();
    if (!pollForm.checkValidity()) {
        pollForm.reportValidity();
        return;
    }

    fetch(pollEndpoint, {
        method: 'POST',
        credentials: 'omit',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            pollId,
            pollResponse,
            turnstileResponse,
        }),
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`Network response was not ok: Status ${response.status}`);
            }
        })
        .then(() => {
            displaySuccessMessage();
            closePoll(3500);
        })
        .catch(error => {
            console.error(error);
            displayErrorMessage();
        });
};

if (pollContainer && window.CookieConsent?.validConsent()) {
    displayPoll(pollDisplayDelay);

    closeButton.addEventListener('click', () => {
        closePoll();
    });

    submitButton.addEventListener('click', event => {
        submitPoll(event);
    });
}
